module.exports = __webpack_public_path__ + "img/db_lorry4.4f08c717.jpeg";